import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogsReturnCode } from 'src/app/enums/dialogs/returnCode.enum';
import { HandlerManager } from 'src/app/managers/handler/handler.manager';
import { LoadingManager } from 'src/app/managers/loading/loading.manager';
import { SessionManager } from 'src/app/managers/session/session.manager';
import { User } from 'src/app/beans/login/user/user.bean';
import { Service } from 'src/app/beans/service/service.bean';
import { CalendarMin } from 'src/app/beans/calendar/calendar.min';
import { CalendarDayFilter } from 'src/app/beans/calendar/calendar.day.filter';
import { Device } from 'src/app/beans/device/device.bean';
import { Result } from 'src/app/beans/result/result.bean';
import { UtilsManager } from 'src/app/managers/utils/utils.manager';

@Component
  ({
    selector: 'time-dialog',
    templateUrl: './time.dialog.html',
    styleUrls: ['./time.dialog.scss'],
  })

export class TimeDialog implements OnInit 
{
  private _generic: Service | Device
  public _calendar: CalendarMin
  public days     : CalendarDayFilter[]

  private calendarId: number
  private type      : string

  private openHour   : string
  private closeHour  : string
  private openMinute : string
  private closeMinute: string

  open : any
  close: any

  constructor
    (
      private dialogRef: MatDialogRef<TimeDialog>,
      @Inject(MAT_DIALOG_DATA) public data: any,

      private _handler: HandlerManager,
      private _loader: LoadingManager,
      private _session: SessionManager,
      private _util: UtilsManager,
  ) { }

  ngOnInit(): void 
  {
    //Set service
    this._generic = this.data.generic

    //Set CalendarId
    this.calendarId = this.data.calendarId

    //Set Object
    this._calendar = {
      calendarId: this.calendarId,
      dow       : null,
      timeId    : null,
      open      : null,
      close     : null,
      enabled   : 0
    }

    //Set type (Device/Service)
    this.type = this.data.type

    //Set days Array
    this.days = this.data.days
  }

  //---------------------------------------------------------------------------------------------------

  async create() 
  {
    this.formatTime()

    let response = null


    if( this.open && this.close) response = await this.changeValue(this.openHour + ":" + this.openMinute + ":00", this.closeHour + ":" + this.closeMinute + ":00")
    
    else if ( this.open  ) response = await this.changeValue(this.openHour + ":" + this.openMinute + ":00", null  )
    else if ( this.close ) response = await this.changeValue(null, this.closeHour + ":" + this.closeMinute + ":00")

    else response = this.changeValue(null, null)

    this.acceptOperation(response)
  }

  acceptOperation(response: any)
  {
    if(Result.isKind(response) && response.result == 1)
    {
      this.dialogRef.close
      ( 
        {
          code: DialogsReturnCode.CALENDAR_OPERATION_ACCEPTED
        }
      )
    }
  }

  cancel() {
    this.dialogRef.close
      (
        {
          code: DialogsReturnCode.OPERATION_DECLINED
        }
      )
  }

  //---------------------------------------------------------------------------------------------------

  async changeValue(open: string, close: string) 
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return

    this._loader.start()

    if(!this.calendarId) this.calendarId = 0

    let response = null
    if (this.type === "service") response = await this._handler.service().updateCalendar((user as User).token, this._generic.id, this.calendarId, this._calendar.dow, open, close)
    if (this.type === "device" ) response = await this._handler.device ().updateCalendar((user as User).token, this._generic.id, this.calendarId, this._calendar.dow, open, close)

    this._loader.stop()

    return response
  }

  //---------------------------------------------------------------------------------------------------

  formatTime() 
  {
    if ( this.open ) {

      this.openHour    = this.open.hour
      this.openMinute  = this.open.minute

      if (this.open.hour < 10) {
        this.openHour = "0" + this.open.hour
      }

      if (this.open.minute < 10) {
        this.openMinute = "0" + this.open.minute
      }
    }

    if ( this.close )
    {
      this.closeHour   = this.close.hour
      this.closeMinute = this.close.minute
      
      if (this.close.hour < 10) {
        this.closeHour = "0" + this.close.hour
      }

      if (this.close.minute < 10) {
        this.closeMinute = "0" + this.close.minute
      }
    }
  }
}
